import moment from "moment";

export const holy_quran_indexes = [
  {
    part: 1,
    min: 1,
    max: 20,
  },
  {
    part: 2,
    min: 21,
    max: 38,
  },
  {
    part: 3,
    min: 39,
    max: 56,
  },
  {
    part: 4,
    min: 57,
    max: 74,
  },
  {
    part: 5,
    min: 75,
    max: 92,
  },
  {
    part: 6,
    min: 93,
    max: 110,
  },
  {
    part: 7,
    min: 111,
    max: 128,
  },
  {
    part: 8,
    min: 129,
    max: 146,
  },
  {
    part: 9,
    min: 147,
    max: 164,
  },
  {
    part: 10,
    min: 165,
    max: 182,
  },
  {
    part: 11,
    min: 183,
    max: 200,
  },
  {
    part: 12,
    min: 201,
    max: 218,
  },
  {
    part: 13,
    min: 219,
    max: 236,
  },
  {
    part: 14,
    min: 237,
    max: 254,
  },
  {
    part: 15,
    min: 255,
    max: 272,
  },
  {
    part: 16,
    min: 273,
    max: 290,
  },
  {
    part: 17,
    min: 291,
    max: 308,
  },
  {
    part: 18,
    min: 309,
    max: 326,
  },
  {
    part: 19,
    min: 327,
    max: 344,
  },
  {
    part: 20,
    min: 345,
    max: 362,
  },
  {
    part: 21,
    min: 363,
    max: 380,
  },
  {
    part: 22,
    min: 381,
    max: 398,
  },
  {
    part: 23,
    min: 399,
    max: 416,
  },
  {
    part: 24,
    min: 417,
    max: 434,
  },
  {
    part: 25,
    min: 435,
    max: 452,
  },
  {
    part: 26,
    min: 453,
    max: 470,
  },
  {
    part: 27,
    min: 471,
    max: 488,
  },
  {
    part: 28,
    min: 489,
    max: 508,
  },
  {
    part: 29,
    min: 509,
    max: 528,
  },
  {
    part: 30,
    min: 529,
    max: 549,
  },
];

export const NOORANI_QAIDA_MAX_PAGES = 32;
export const MADANI_QAIDA_MAX_PAGES = 40;
export const HOLY_QURAN_MAX_PAGES = 549;

export const get_min_max_page_value = (part_number) => {
  if (part_number && part_number > 0 && part_number < 31) {
    return holy_quran_indexes.filter((page) => page.part === part_number)[0];
  } else {
    return {
      part: 0,
      min: 0,
      max: 0,
    };
  }
};

export const get_short_string = (str, limit = 30) => {
  return str && str.length < limit ? str : str?.slice(0, limit) + "...";
};

export const show_proper_words = (text) => {
  let replace_string = "";
  if (text) {
    // Replace hyphens and underscores with spaces
    replace_string = text.replace(/[-_]/g, " ");
    // Capitalize the first letter of every word
    replace_string = replace_string
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  return replace_string;
};

export const sidebar_pathname = (pathname) => {
  if (pathname) {
    const pathParts = pathname.split("/");
    if (pathParts.length > 2) {
      return pathParts.slice(0, 2).join("/");
    } else {
      return pathname;
    }
  }
};

export const format_date = (date) => {
  return moment(date).format("DD-MM-YYYY hh:mm A");
};

export function generateRandomID(length) {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let id = "";
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    id += characters.charAt(randomIndex);
  }
  return id;
}

export const textCopyToClipboard = (text) => {
  return navigator.clipboard
    .writeText(text)
    .then(() => true)
    .catch(() => false);
};

export const filter_members = (usersArray, usersToRemove) => {
  const idsToRemove = new Set(usersToRemove.map((user) => user._id));
  return usersArray.filter((user) => !idsToRemove.has(user._id));
};
